import { render } from "./SinglePageService.vue?vue&type=template&id=7cd5e38b"
import script from "./SinglePageService.vue?vue&type=script&lang=js"
export * from "./SinglePageService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__